module.exports = __webpack_public_path__ + "img/notes-img.b8edf1c7.png";